var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 99,
    viewBox: "0 0 99 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.7319 4.03449C95.7319 3.33785 94.9211 2.80388 94.2244 2.80388C93.0819 2.80388 91.8809 2.80388 90.8094 2.80388C80.7185 3.29613 71.1198 5.51121 62.0133 9.94139C50.9379 15.1099 41.5853 22.4935 34.2017 32.3384C29.0331 38.9836 25.3413 46.3673 22.634 54.2431C22.3879 54.7354 22.634 54.9815 22.8801 55.2276C25.0952 57.4427 27.3103 59.6578 29.5254 61.8729C29.7715 62.119 30.0176 62.6112 30.0176 63.1035C30.0176 63.5957 29.7715 64.088 29.2793 64.3341C28.3021 64.8226 27.4087 63.6941 26.6362 62.9216C25.8885 62.174 25.1774 61.4629 24.3568 60.6423C22.8801 59.1656 21.6495 57.6888 20.1728 56.4582C19.6805 55.966 19.4344 55.2276 19.6805 54.4893C22.8801 44.8905 27.5564 36.0302 34.2017 28.1543C40.8469 20.0323 48.9689 13.6332 58.0754 8.9569C66.4435 4.52673 75.55 1.8194 84.9026 0.588796C88.8405 0.0965543 92.7784 -0.149566 96.7164 0.0965544C97.3814 0.0965544 97.7589 0.240324 98.0043 0.566713C98.5387 1.27749 98.4564 2.26646 98.47 3.1556C98.7081 18.6405 94.7532 32.9691 86.3793 46.3673C77.765 59.9039 65.9513 69.9949 51.184 76.394C48.9689 77.3785 46.5077 78.1169 44.0465 79.1013C43.9105 79.1467 43.7829 79.1836 43.6621 79.2092C42.6313 79.4273 41.9485 78.2339 41.2035 77.4889C39.0574 75.3429 36.7867 73.0721 34.6939 70.9794C34.2017 70.4871 33.9555 69.7487 34.4478 69.0104C34.94 68.272 35.9245 68.272 36.6629 69.0104C38.878 71.2255 41.0931 73.4406 43.3081 75.6557C43.8004 76.1479 44.0465 76.1479 44.5387 75.9018C55.3681 72.21 64.9668 66.3031 73.0888 58.4272C82.6875 49.0746 89.0866 37.9992 92.7784 25.447C94.7474 18.5556 95.7319 11.4181 95.7319 4.03449Z",
    fill: "url(#paint0_linear_2305_20635)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9486 31.6032C81.9486 39.9713 75.3034 46.6166 66.9352 46.6166C58.5671 46.6166 51.9219 39.9713 51.9219 31.6032C51.9219 23.4812 58.5671 16.5898 66.6891 16.5898C75.3034 16.5898 81.9486 23.2351 81.9486 31.6032ZM78.9952 31.8493C78.9952 24.958 73.5805 19.5433 66.6891 19.5433C59.7977 19.5433 54.3831 24.958 54.3831 31.8493C54.3831 38.7407 59.7977 44.1554 66.6891 44.1554C73.5805 43.9093 78.9952 38.4946 78.9952 31.8493Z",
    fill: "url(#paint1_linear_2305_20635)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.318 88.6716C43.7686 91.5222 46.9989 93.0096 49.216 91.1621C54.1384 86.7319 56.8457 81.3173 58.0763 74.9181C58.3224 73.9336 58.8147 73.4414 59.553 73.4414C59.9299 73.4414 60.2347 73.5496 60.4673 73.7384C61.2853 74.4025 60.9386 75.6872 60.7207 76.7181C60.549 77.5304 60.3418 78.3609 60.0453 79.1022C57.3379 87.4703 52.4155 93.6233 44.7858 97.8074C43.0629 98.7918 42.3246 98.2996 42.0784 96.5768C41.1159 91.5232 40.1533 86.2343 39.1907 81.1702C39.147 80.9405 39.125 80.6428 39.125 80.409C39.125 79.8308 39.2217 79.2347 39.7528 79.0063C39.9857 78.9061 40.2687 78.8561 40.6017 78.8561C41.6945 78.8561 41.9145 80.3902 42.1129 81.4648C42.2546 82.232 42.4194 83.0223 42.6397 83.868C42.7524 84.3007 42.8309 84.7418 42.871 85.1872C42.9771 86.3674 43.1362 87.5222 43.318 88.6716Z",
    fill: "url(#paint2_linear_2305_20635)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.80109 53.1551C3.91279 53.5788 4.2838 54.0994 4.7159 54.1721C5.8371 54.3607 6.92451 54.5493 7.86744 54.7378C11.2422 55.461 14.6171 55.9481 17.7606 56.6616C17.8922 56.6914 18.0369 56.7068 18.1718 56.7068C18.3634 56.7068 18.5472 56.7305 18.7157 56.8216C19.3008 57.1381 19.6504 57.7839 19.4351 58.4297C19.189 59.168 18.6968 59.6603 17.7123 59.4141C15.7433 58.9219 13.5282 58.6758 11.5592 58.1835C8.43688 57.463 5.31451 56.9768 1.96341 56.2676C1.79793 56.2326 1.63121 56.2146 1.46206 56.2146C1.30391 56.2146 1.14288 56.2022 0.990693 56.1592C-0.0377759 55.8686 -0.221972 55.1486 0.23769 53.9995C1.71442 51.2922 3.43726 48.5848 5.65235 46.3697C10.3083 41.4688 15.9401 38.7636 22.305 37.2826C22.3604 37.2697 22.4318 37.2637 22.4887 37.2626C22.8123 37.2565 23.0943 36.923 23.4156 36.9619C23.9511 37.0267 24.4178 37.444 24.6037 38.0016C24.8498 38.74 24.3575 39.4784 23.373 39.7245C21.8963 40.2167 20.1735 40.4628 18.6968 40.9551C12.38 43.1416 7.50219 47.007 3.82658 52.5511C3.73578 52.6881 3.75919 52.9962 3.80109 53.1551Z",
    fill: "url(#paint3_linear_2305_20635)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5442 77.0341C20.9782 76.4842 21.3386 75.4735 21.8966 74.9155C26.5729 70.2392 31.003 65.809 35.6793 61.1327C37.4022 59.4098 38.8789 57.9331 40.6017 56.2103C40.8404 55.9716 41.079 55.8101 41.3177 55.7174C42.2998 55.3359 43.419 56.4596 43.0507 57.4468C42.9562 57.6999 42.7987 57.9513 42.5707 58.1792C37.1561 63.5939 31.7414 69.2547 26.0806 74.6693C25.5057 75.2443 24.9308 75.9684 24.2397 76.6094C23.844 76.9764 23.4576 77.4331 22.9256 77.5239C22.7518 77.5536 22.5779 77.5363 22.404 77.4828C22.2243 77.4276 22.0496 77.3539 21.8817 77.2695C21.7485 77.2025 21.6368 77.1241 21.5442 77.0341Z",
    fill: "url(#paint4_linear_2305_20635)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8528 82.8582C14.4346 82.5013 15.1779 82.4047 15.676 82.8714C15.8011 82.9886 15.9085 83.1237 15.9892 83.2853C16.114 83.5347 16.1123 83.7841 16.0483 84.0336C15.918 84.5412 15.5919 84.8871 15.2509 85.285C14.9098 85.6829 14.5693 86.1811 14.2005 86.5534C11.736 89.0414 9.26075 91.679 6.63181 94.1805C5.98648 94.7946 5.31237 95.5913 4.42157 95.5913C4.29648 95.5913 4.17138 95.5754 4.05033 95.5436C3.31806 95.3513 2.8777 94.4716 3.06644 93.7384C3.12136 93.525 3.23961 93.3276 3.43708 93.1301C5.40605 91.1611 7.37502 89.1922 9.34398 87.2232C10.737 85.8302 11.911 84.6562 13.2791 83.2881C13.4439 83.1233 13.6541 82.9801 13.8528 82.8582Z",
    fill: "url(#paint5_linear_2305_20635)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2673 72.3955C12.5394 72.1779 12.7338 72.1855 13.0663 72.2895C13.6144 72.4608 14.0025 72.8892 14.1298 73.3396C14.2881 73.8994 13.9452 74.4878 13.5408 74.9059C13.5369 74.91 13.5328 74.9141 13.5287 74.9183C10.3291 78.1178 7.12954 81.3174 3.92997 84.517C3.76629 84.6807 3.58936 84.8324 3.38762 84.9459C3.1408 85.0848 2.8977 85.1847 2.66769 85.2175C1.9291 85.3227 1.32664 84.4807 1.34628 83.7349C1.35561 83.3805 1.47848 83.0305 1.71488 82.7941C4.17609 80.3329 6.6373 77.8717 9.09851 75.4105C9.93878 74.5702 10.5998 73.9093 11.3875 73.2745C11.6588 73.0559 11.9952 72.6132 12.2673 72.3955Z",
    fill: "url(#paint6_linear_2305_20635)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3269 85.9952C26.3269 86.7299 25.5696 87.2447 25.0501 87.7642C21.8993 90.915 18.9265 93.8878 15.7437 97.0706C15.0053 97.809 14.267 97.809 13.5286 97.0706C13.372 96.914 13.2652 96.7075 13.2162 96.4829C12.9915 95.4535 14.1501 94.7262 14.8951 93.9812C17.922 90.9544 20.7962 88.0802 23.8657 85.0107C24.0654 84.8109 24.2652 84.6517 24.4814 84.5494C25.1658 84.2258 26.1282 84.6171 26.2761 85.3596C26.31 85.5296 26.3269 85.737 26.3269 85.9952Z",
    fill: "url(#paint7_linear_2305_20635)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2305_20635",
    x1: 28.5976,
    y1: 108.017,
    x2: 123.051,
    y2: 78.4226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A84FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2238FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2305_20635",
    x1: 55.3523,
    y1: 57.5166,
    x2: 91.2713,
    y2: 46.2123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A84FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2238FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2305_20635",
    x1: 41.6275,
    y1: 107.336,
    x2: 68.3709,
    y2: 99.9226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A84FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2238FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2305_20635",
    x1: 2.81804,
    y1: 67.655,
    x2: 31.8045,
    y2: 57.6652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A84FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2238FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2305_20635",
    x1: 23.6718,
    y1: 85.4945,
    x2: 49.9727,
    y2: 77.1853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A84FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2238FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2305_20635",
    x1: 4.52157,
    y1: 100.416,
    x2: 20.1948,
    y2: 95.5681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A84FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2238FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2305_20635",
    x1: 2.81141,
    y1: 89.9548,
    x2: 18.1983,
    y2: 85.1825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A84FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2238FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2305_20635",
    x1: 14.6869,
    y1: 102.417,
    x2: 30.4201,
    y2: 97.4884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A84FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2238FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.d39f097fce9d2f3e9f99d20ac39be1f1.svg";
export { ForwardRef as ReactComponent };